import config from '@/config';

export default {
  apexSimpleRadialBarGeral: {
    series: [70],
    options: {
      chart: {
        type: 'radialBar',
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 5,
            size: '30%',
            background: 'transparent',
            image: undefined,
          },
        },
      },
      labels: ["Impacto", "Realização", "Produtos", "Atividades"],
      colors: ["#1ab7ea", "#0084ff", "#39539E", "#0077B5"],
      legend: {
        show: true,
        floating: true,
        fontSize: "14px",
        position: "right",
        offsetY: -25,
        offsetX: -45,
        formatter: function(seriesName, opts) {
          return seriesName + ":  <b>" + opts.w.globals.series[opts.seriesIndex] + "%</b>";
        },
      },
      tooltip: {
        intersect: false,
      }
    }
  },
  apexSimpleRadialBarImpacto: {
    series: [70],
    options: {
      chart: {
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '60%',
          }
        },
      },
      labels: ['Progresso'],
      colors: ['#1ab7ea'],
    }
  },
  apexSimpleRadialBarRealizacao: {
    series: [70],
    options: {
      chart: {
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '60%',
          }
        },
      },
      labels: ['Progresso'],
      colors: ['#0084ff'],
    }
  },
  apexSimpleRadialBarProduto: {
    series: [70],
    options: {
      chart: {
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '60%',
          }
        },
      },
      labels: ['Progresso'],
      colors: ['#39539E'],
    }
  },
  apexSimpleRadialBarAtividade: {
    series: [70],
    options: {
      chart: {
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '60%',
          }
        },
      },
      labels: ['Progresso'],
      colors: ['#0077B5'],
    }
  },
  apexBarAtividades: {
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },
      colors: ['#536dfe'],
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'top', // top, center, bottom
          },            
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%";
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#304758"]
        }

      },
      xaxis: {
        categories: [],
        labels: {
          formatter: function (value) {
            return value[1].toUpperCase().replace('ATIVIDADE', '')
          }
        },
      },
      yaxis: {
        max: 100,
        title: {
          text: 'Progresso da Atividade (%)',
        },
        labels: {
          formatter: function (value) {
            return value + "%";
          }
        },
      },
      tooltip: {
        intersect: false,
        x: {
          formatter: function (value) {
            return value[0] + '<br>' + value[1] + '<br>' + value[2]
          }
        }
      },

    },
  },
  apexPie1: {
    options: {
      chart: {
        type: 'radialBar'
      },
      dataLabels: {
        enabled: false
      },
      colors: [config.light.success],
      legend: {
        show: false,
      },
      stroke: {
        dashArray: 4
      },
      plotOptions: {
        radialBar: {
          startAngle: -180,
          endAngle: 180,
          hollow: {
            size: '60',
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: true,
              offsetY: 8,
              fontSize: '16px',
              color: config.light.greyTint
            },
          }
        }
      }
    },
    series: [100],
  },


};
